import { MapPin } from "lucide-react";

interface OrganizationInfoProps {
  organization: {
    name: string;
    description: string | null;
    location: string | null;
  };
}

export const OrganizationInfo = ({ organization }: OrganizationInfoProps) => {
  return (
    <div>
      <h3 className="font-semibold mb-2">Organization</h3>
      <div className="p-4 bg-muted/50 rounded-lg">
        <h4 className="font-medium">{organization.name}</h4>
        <p className="text-sm text-muted-foreground mt-1">
          {organization.description}
        </p>
        {organization.location && (
          <p className="text-sm text-muted-foreground mt-1">
            <MapPin className="w-4 h-4 inline mr-1" />
            {organization.location}
          </p>
        )}
      </div>
    </div>
  );
};